/* eslint-disable */
import React, { useEffect, useImperativeHandle, useState } from "react"
import PrimaryButton from "../../../../../components/molecules/buttons/PrimaryButton.molecule"
import { useNavigate } from "react-router-dom"
import { AppRoutes } from "../../../../../consts/appRoutes.consts"
import useToast from "../../../../../hooks/useToast.hook"
import useReportFiltersContext from "../../../../../hooks/contextConsumers/useReportFiltersContext.hook"
import DangerButton from "../../../../../components/molecules/buttons/DangerButton.molecule"
import {
  createProject,
  deleteProject,
  editProject,
} from "../../../../../services/project.service"
import { checkValidationsAndIfHaveErrors } from "../../../../../utils/validations.utils"
import { SISU_CLIENTS } from "../../../../../consts/modules/clients.consts"
import { useNavigationBlock } from "../../../../../contexts/NavigationBlock.context"

const FormProjectFooter = ({
  client,
  project,
  error: formError,
  isCreate,
  validations,
  loading,
  saving,
  deleting,
  setSaving,
  setDeleting,
  callSubmit,
  changedFormData,
}) => {
  const [error, setError] = useState(null)
  const navigate = useNavigate()
  const { setErrorMessage } = useToast()
  const { refreshFiltersContext } = useReportFiltersContext()
  const { unblock } = useNavigationBlock()

  useEffect(() => {
    setError(formError)
  }, [formError])

  const handleSubmitProject = async () =>
    new Promise(async (resolve, reject) => {
      setSaving(true)
      setError(null)
      try {
        const service = isCreate ? createProject : editProject
        const response = await service({
          project,
          modules: project.modules,
        })
        if (!response.success) {
          throw new Error(response.message)
        }
        setSaving(false)
        refreshFiltersContext()
        setError(null)
        unblock()
        resolve()
      } catch (error) {
        setSaving(false)
        setError(error)
        setErrorMessage({
          title: "Error",
          message: error.message,
        })
        reject(error)
      }
    })

  useImperativeHandle(callSubmit, () => {
    return {
      handleSubmitProject,
    }
  })

  const handleDeleteProject = async () => {
    setDeleting(true)
    setError(null)
    try {
      const response = await deleteProject(project.id)
      if (!response.success) {
        throw new Error(response.message)
      }
      unblock()
      navigate(AppRoutes.clientes.detalles, {
        state: {
          clientId: client.id || client.client.id,
        },
      })
    } catch (error) {
      setError(error)
      setDeleting(false)
      setErrorMessage(error.message)
    } finally {
      setDeleting(false)
      refreshFiltersContext()
    }
  }

  const handleIconLoading = (icon, loading = saving) =>
    loading ? "spinner pi-spin" : icon

  return (
    <div
      className={`flex w-full justify-content-end mt-3 gap-3 footer-buttons ${changedFormData ? "sticky-footer" : ""}`}
    >
      {(
        !loading &&
        !isCreate &&
        project.isProjectDeletable &&
        client.projects?.length > 1
      ) ?
        <DangerButton
          label="Eliminar"
          btnType="outlined"
          icon={`pi pi-${handleIconLoading("trash", deleting)}`}
          rounded
          onClick={handleDeleteProject}
          loading={saving}
        />
      : null}
      <PrimaryButton
        label={isCreate ? "Crear" : "Guardar"}
        icon={`pi pi-${handleIconLoading(isCreate ? "plus" : "check")}`}
        onClick={() =>
          handleSubmitProject().then(() => {
            navigate(AppRoutes.clientes.detalles, {
              state: {
                clientId: client.id || client.client.id,
              },
            })
          })
        }
        disabled={
          !changedFormData ||
          (!SISU_CLIENTS.includes(client.client?.id) ?
            (error && Object.values(error).some((value) => value)) || saving
          : false)
        }
      />
    </div>
  )
}

export default FormProjectFooter
